// Centralised catalogue sizes — the single source of truth for the
// number of widgets and SEO tools shipped on FeedPulse.
//
// Why this file exists:
// Until v60.23 the homepage headline, homepage CTA, widget gallery H1,
// footer "Browse all" link, "All N tools" links, and the dashboard
// bookmark cross-link all hard-coded "12", "13", "14" etc. as English
// digits and spelled-out words across half a dozen files. Every time
// we shipped a new widget or SEO tool those strings drifted apart
// (v60.21 forgot the footer's "Browse all 12 →", v60.22 forgot the
// "All 12 tools →" in the SEO Tools dropdown, and so on).
//
// Now each surface imports `WIDGET_COUNT` / `SEO_TOOL_COUNT` (and
// optionally `widgetCountWord()` / `seoToolCountWord()` for the H1s
// that use the spelled-out form), so future widgets auto-update
// everywhere with zero copy edits.
import { UTIL_WIDGETS } from "./util_widgets";
import { SEO_TOOLS } from "./seo_tools";

export const WIDGET_COUNT = UTIL_WIDGETS.length;
export const SEO_TOOL_COUNT = SEO_TOOLS.length;

// English number-word table — covers every catalogue size we're
// realistically going to ship (≤ 30). For anything bigger we fall
// through to the digit form rather than inventing weird "thirty-one"
// hyphenated copy at runtime.
const NUMBER_WORDS = [
  "Zero", "One", "Two", "Three", "Four", "Five",
  "Six", "Seven", "Eight", "Nine", "Ten", "Eleven",
  "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen",
  "Eighteen", "Nineteen", "Twenty", "Twenty-one", "Twenty-two",
  "Twenty-three", "Twenty-four", "Twenty-five", "Twenty-six",
  "Twenty-seven", "Twenty-eight", "Twenty-nine", "Thirty",
];

/** Spell out a small integer ("Fourteen") or fall through to the digit
 *  form ("31") for anything past the table. Used in H1s where digits
 *  look thin against the heavy display-font weight. */
export const numberWord = (n) => NUMBER_WORDS[n] || String(n);

export const widgetCountWord = () => numberWord(WIDGET_COUNT);
export const seoToolCountWord = () => numberWord(SEO_TOOL_COUNT);
